import request from '@/utils/request'

// 查询列表
export function apiScpConcurrentRequestsList (query) {
  return request({
    url: '/scp/scpConcurrentRequests/list',
    method: 'get',
    params: query
  })
}

// 强制终止
export function apiScpMrpPlansAbortPlan (data) {
  return request({
    url: '/scp/scpMasterControl/terminated',
    method: 'get',
    params: data
  })
}
